import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { Maybe } from '@/lib/types';

export const Container = styled(Box)<{
  backgroundImage: Maybe<string>;
  hasHours?: boolean;
  id: Maybe<string>;
}>`
  position: relative;
  width: 100%;
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 289px;
  cursor: pointer;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #0e2240;
    opacity: 0.5;
    z-index: 2;
  }
  &:hover::after {
    opacity: 0.7;
    transition: opacity 0.3s ease-in-out;
  }
  ${({ id, theme }) => css`
    padding: ${theme.spacing(0, 1)};
    gap: ${theme.spacing(1)};
    ${theme.media.md.up} {
      background-position: ${id === 'call' ? 'right' : 'center'};
      height: 100%;
    }
  `}
`;
export const IconWrapper = styled(Box)`
  position: relative;
  height: 48px;
  width: 48px;
  z-index: 3;
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(1)};
  `}
`;
export const HeaderWrapper = styled(Box)`
  z-index: 3;
`;
export const Text = styled(Box)`
  color: white;
  text-align: center;
  font-size: 14px;
  z-index: 3;
`;

export const TextGroup = styled(Box)`
  ${({ theme }) => css`
    padding-left: ${theme.spacing(4)};
    padding-right: ${theme.spacing(4)};
    z-index: 3;
  `};
`;

export const HihglightDays = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;
